import type React from "react";
import { TextField, type TextFieldProps } from "@mui/material";
import { formatRupiahInputValue, parseRupiahInput } from "../../utils/formatRupiah";

interface RupiahAmountFieldProps extends Omit<TextFieldProps, "value" | "onChange" | "type"> {
  value: string;
  onValueChange: (value: string) => void;
}

const RupiahAmountField: React.FC<RupiahAmountFieldProps> = ({
  value,
  onValueChange,
  inputProps,
  ...props
}) => {
  return (
    <TextField
      {...props}
      value={formatRupiahInputValue(value)}
      onChange={(event) => onValueChange(parseRupiahInput(event.target.value))}
      inputProps={{
        ...inputProps,
        inputMode: "numeric",
      }}
    />
  );
};

export default RupiahAmountField;
